import { render, staticRenderFns } from "./AmDataMainPage.vue?vue&type=template&id=6f18c5d0&scoped=true&"
import script from "./AmDataMainPage.vue?vue&type=script&lang=js&"
export * from "./AmDataMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18c5d0",
  null
  
)

export default component.exports